import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import { Api_Endpoints } from '../../Api/apiEndpoint';
import { makeApiCall } from '../../Api/makeApiCall';
import { getUserSession } from "../../utils/auth";
import Dropdown from "../ui/Dropdown";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import './FilterContainer.css'; // Import the external CSS file

const FilterContainer = ({ dropdownData, searchData, ResetList, pageType }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
  const [VendorDropdown, setVendorDropDown] = useState({});
  const [InvoiceDropDown, setInvoiceDropDown] = useState({});
  const [filteredData, setFilteredData] = useState({});
  const [dateRange, setDateRange] = useState([]);
  const user_data = getUserSession();
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setError("");
  };

  const getVendorDropDown = async () => {
    const res = await makeApiCall(Api_Endpoints.DASHBOARD_DROPDOWN, "GET");
    if (res?.status) {
      setVendorDropDown(res?.data.vendor);
      setInvoiceDropDown(res?.data.vendor);
    }
  };

  const handleDropdownChange = (value, label) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [label]: value,
    }));
  };

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      setDateRange([
        dates[0].format("YYYY-MM-DD"),
        dates[1].format("YYYY-MM-DD"),
      ]);
    } else {
      setDateRange([]);
    }
  };

  const handleExcelDownload = async () => {
    try {
      if (!user_data?.token) {
        alert('Please login to download the report');
        return;
      }

      if (!dateRange[0] || !dateRange[1]) {
        alert('Please select date range');
        return;
      }

      const formData = new FormData();
      formData.append('from_date', dateRange[0]);
      formData.append('to_date', dateRange[1]);

      const response = await axios({
        method: 'POST',
        url: Api_Endpoints.EXCEL_STATEMENT_DOWNLOAD,
        data: formData,
        headers: {
          'Authorization': `Bearer ${user_data.token}`,
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'blob',
        timeout: 30000
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `invoice_report_${dateRange[0]}_to_${dateRange[1]}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        setError("Failed to download Excel report");
      }
    } catch (error) {
      console.error("Error downloading Excel report:", error);
      if (error.response?.status === 401) {
        setError("Session expired. Please login again.");
      } else {
        setError("Error downloading Excel report. Please try again.");
      }
    }
  };

  const handleReset = () => {
    setSearchQuery("");
    setSelectedFilters({});
    setDateRange([]);
    ResetList();
  };

  const handleSubmit = async () => {
    let endpoint;
    let requestData = {};
    setError("");
    
    const isSearching = searchQuery.trim() !== '';
    
    if (isSearching) {
      endpoint = pageType === 'invoice' ? Api_Endpoints.INVOICE_SEARCH : Api_Endpoints.VENDOR_SEARCH;
      requestData.search = searchQuery;
    } else {
      endpoint = pageType === 'invoice' ? Api_Endpoints.INVOICE_FILTER : Api_Endpoints.VENDOR_FILTER;
    }

    if (selectedFilters?.vendor_filter && pageType === 'vendor') {
      requestData.vendor_status = selectedFilters.vendor_filter.target?.value;
    }
    if (selectedFilters?.invoice_filter && pageType === 'invoice') {
      requestData.invoice_status = selectedFilters.invoice_filter.target?.value;
    }
    if (dateRange && dateRange.length === 2) {
      requestData.start_date = dateRange[0];
      requestData.end_date = dateRange[1];
    }

    try {
      const response = await makeApiCall(endpoint, "POST", requestData);
      
      if (response?.status) {
        setFilteredData(response);
        searchData(response.result);
        setError("");
      } else {
        setError(response?.message || `No ${pageType}s found`);
        searchData([]);
      }
    } catch (error) {
      setError(`Error fetching ${pageType} data. Please try again.`);
      console.error(`Error fetching ${pageType} data:`, error);
    }
  };

  useEffect(() => {
    getVendorDropDown();
  }, []);

  return (
    <div className="filter-container">
      {/* {error && (
        <div className="error-message">
          <span className="error-icon">⚠️</span>
          <span className="error-text">{error}</span>
        </div>
      )} */}

      <div className="filter-main-row">
        {/* Dropdowns from map */}
        {dropdownData.map((dropdown, index) => (
          <select
            key={index}
            className="filter-dropdown"
            onChange={(e) => handleDropdownChange(e.target.value, dropdown.label)}
            value={selectedFilters[dropdown.label] || ""}
          >
            <option value="">{dropdown.placeholder}</option>
            {dropdown.options.map((option, idx) => (
              <option key={idx} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ))}

        {/* Search Input */}
        <div className="search-bar">
          <input
            type="text"
            placeholder={`Search ${pageType === 'invoice' ? 'Invoices' : 'Vendors'}...`}
            value={searchQuery}
            onChange={handleSearchChange}
            className="search-input"
          />
        </div>

        {/* Custom Dropdown */}
        <div className="form-group-Dropdown-filter">
          <Dropdown
            onChange={(e) => handleDropdownChange(e, pageType === 'invoice' ? 'invoice_filter' : 'vendor_filter')}
            options={pageType === 'invoice' ? InvoiceDropDown.invoice_filter : VendorDropdown.vendor_filter}
            inputClassName={'bankDropDown'}
          />
        </div>

        {/* Right-aligned buttons group */}
        <div className="button-group">
          <button 
            className="filter-btn submit-btn" 
            onClick={handleSubmit}
          >
            Submit
          </button>
          
          <button 
            className="filter-btn reset-btn" 
            onClick={handleReset}
          >
            Reset
          </button>
          
          {user_data?.user !== 'Maker' && 
           user_data?.user !== 'Checker' &&
           user_data?.user !== 'Checker1' &&
           user_data?.user !== 'Chairman' &&
           user_data?.user !== 'Director_1' &&
           user_data?.user !== 'Director_2' &&
           user_data?.user !== 'Director_3' &&
           user_data?.user !== 'Director_4' &&
           user_data?.user !== 'Director_5' && 
           user_data?.user !== 'Account' && 
           user_data?.user !== 'coo' && 
           user_data?.user !== 'Ceo' && 
           user_data?.user !== 'Independent_director' &&
           user_data?.user !== 'Manager' && (
            <DatePicker.RangePicker
              onChange={handleDateChange}
              className="date-picker"
              format="YYYY-MM-DD"
            />
          )}
          
          {user_data?.user === 'Finance' && (
            <button 
              className="filter-btn excel-btn" 
              onClick={handleExcelDownload}
            >
              Download Excel
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterContainer;